/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';

import CombinedCompareTable from 'components/lwstats/CombinedCompareTable';
import CompareChartHeader from 'components/lwstats/CompareChartHeader';

import classNames from 'classnames';
/**
* Compare Card react view
* Customizes ExploreCardView - provides overview & stats tables for each visualization in the compare card
*/
@observer
export class CompareCardView extends Component {
	constructor(props) {
		super(props);
		this.headerMap = null;
	}

	render() {
		//Uses function as children react pattern
		//Child react component is a function that renders ExploreCardView, but passes in 2 params
		//to render the 'card' overview (for compare, show a compare specific overview)
		//and visualization 'header' (for compare, shows stats for the visualization)
		const model = this.props.model;
		const compareModel = model.compareModel;

		const showCompareTable = compareModel && model.shouldShowCompareTable(compareModel);
		const compareTable = showCompareTable ? <CombinedCompareTable compareModel={compareModel} /> : null;
		const getFooterView = () => { return compareTable; };

		const headerMap = this._getWidgetHeaderMap();
		const renderPopOver = compareModel.renderPopOver;

		const getWidgetHeaderMap = () => { return headerMap; };
		const getCssClasses = this.getCardStyleClasses;
		const getCrossHairMatchingPoints = compareModel.getCrossHairMatchingPoints;
		return this.props.children(null, getWidgetHeaderMap, getFooterView, getCssClasses, getCrossHairMatchingPoints, renderPopOver );
	}

	getCardStyleClasses() {
		const containsPlaceholder = this.model.getVisualizations().find(widget => widget.placeholder);
		const classNamesMain = classNames({
			'card-layout-main': true
		});
		const classNamesCardRow = classNames({
			'card-row': !containsPlaceholder,
			'card-row-placeholder': containsPlaceholder
		});
		return {
			classNamesMain: classNamesMain,
			classNamesCardRow: classNamesCardRow
		};
	}

	_getWidgetHeaderMap() {
		const model = this.props.model;
		const compareModel = model.compareModel;
		const headerMap = {};
		void(compareModel.widgetUpdatedCount);

		model.getVisualizations().map(
			(o) => {
				const id = o.widgetLayout ? o.widgetLayout.id : o.placeholder.id;
				let header = null;
				const m = o.widgetLayout ? compareModel.getStatsModel(id): null;
				if( m ) {
					const subLabel = compareModel.getWidgetSubLabel(id);
					header = <CompareChartHeader key={id} label={compareModel.getWidgetAlias(id)} subLabel={subLabel} />;
				}
				headerMap[id] = header;
			}
		);

		return headerMap;
	}
}

CompareCardView.propTypes = {
	model: PropTypes.object,
	children: PropTypes.any
};



// WEBPACK FOOTER //
// ./src/js/layout/explorecard/compare/CompareCardView.js